import { render } from "./CustomSelectOneHorseStatus.vue?vue&type=template&id=30fe2ae9"
import script from "./CustomSelectOneHorseStatus.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneHorseStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__